module.exports = __webpack_public_path__ + "static/media/advertisingimg.68b68dd9.png";